import React from "react";
import "./Actions.scss";
import { FiDownload } from "react-icons/fi";
import { CSVLink } from "react-csv";
import PropTypes from "prop-types";
import SpwFilter from "../SpwFilter/SpwFilter";
import { REGEXSEARCHURLPATHNAME } from "../../RegEx";
import Authorization from "../Authorization/Authorization";

const downloadFile = (data) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `gauss_filtered.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

async function gaussDownloadData(displayCatalogueData, gaussDownloadCallback) {
  if(displayCatalogueData.length > 0) {
    const sourceIds = displayCatalogueData.map(row => row.id);
    let currentData = await gaussDownloadCallback(sourceIds);
    if(currentData?.data) {
      downloadFile(currentData.data);
    }
  }
}

function showGaussDownload(displayCatalogueData, gaussDownloadPost) {
  if( displayCatalogueData.length > 0 && 'source_name' in displayCatalogueData[0]) {
    return <a
            className="download"
            onClick={() => gaussDownloadData(displayCatalogueData, gaussDownloadPost)}
           >
            Filtered Gauss Table
            <FiDownload style={{ marginLeft: "9px", minWidth: "10px" }} />    
           </a>;

  }
  
  return <></>;
}

function Actions({ displayCatalogueData, gaussDownloadPost }) {
  const RegExForSearchPathName = new RegExp(REGEXSEARCHURLPATHNAME);
  let isSearchPageURL = RegExForSearchPathName.test(window.location.pathname);
  return (
    <div className="user-actions-container">
      <div className="user-action-header">
        <h3>Actions</h3>
      </div>
      <div className="user-actions">
        {!isSearchPageURL && <Authorization><SpwFilter /></Authorization> }
        <div className="download-wrapper">  
          <CSVLink
            data={displayCatalogueData}
            filename={"catalogue" + `_table.csv`}
            className="download"
          >
            Filtered Table
            <FiDownload style={{ marginLeft: "9px", minWidth: "10px" }} />
          </CSVLink>
         {showGaussDownload(displayCatalogueData, gaussDownloadPost)}
        </div>
      </div>
    </div>
  );
}

Actions.propTypes = {
  displayCatalogueData: PropTypes.array.isRequired,
};

export default Actions;
